import { reduxForm } from 'redux-form';
import { useTranslation } from 'react-i18next';
// import moment from 'moment';

import { Filters } from 'libs/form';

// const d = moment();
const initialFlt = {
  // status: 'active',
  // datetime_from: d.startOf('day').format(),
  // datetime_to: d.endOf('day').format(),
};

const Filter = ({ handleSubmit, reset, type, change }) => {
  const { t } = useTranslation();

  const filters = [
    { type: 'doubledate', name: 'violation_time', title: t('grid.Период нарушения'), change },
    { type: 'input', name: 'vehicle_plate', title: t('sections.ГРЗ'), placeholder: t('form.А000AA 000 rus'), w: 150 },
    { type: 'dict', dict: 'violations.status' },
    {
      type: 'meandouble',
      dict: 'stays.mean_type',
      multiple: true,
      name: 'mean_id',
      placeholder: '55030',
      label: t('grid.СО'),
      w: 120,
    },
  ];

  return <Filters items={filters} page={type} handleSubmit={handleSubmit} reset={reset} t={t} />;
};

export default reduxForm({
  form: 'violationsFilter',
  destroyOnUnmount: false,
  initialValues: initialFlt,
})(Filter);
